// extracted by mini-css-extract-plugin
module.exports = {"detailBlock":"DetailBlock_detailBlock__2JX94","header":"DetailBlock_header__2Ijqa","title":"DetailBlock_title__1frCv","content":"DetailBlock_content__2o0fO"};